import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import styles from './Dashboard.module.scss'

export default function AccountRow({ icon, label, value, open, onToggle, children }) {
    return (
        <div className={styles.row}>
            <button type="button" className={styles.rowHeader} onClick={onToggle} aria-expanded={open}>
                <span className={styles.rowIcon}>
                    <FontAwesomeIcon icon={icon}/>
                </span>
                <span className={styles.rowText}>
                    <span className={styles.rowLabel}>{label}</span>
                    <span className={styles.rowValue}>{value}</span>
                </span>
                <span className={`${styles.rowChevron} ${open ? styles.rowChevronOpen : ''}`}>
                    <FontAwesomeIcon icon={faChevronDown}/>
                </span>
            </button>
            {open && <div className={styles.rowContent}>{children}</div>}
        </div>
    )
}
